import type { Metadata } from 'next';

import { localeDefinitions, type Locale } from '@/i18n/locales';

export type SeoLocale = Locale;

export const SITE_NAME = 'DOBIDOBI';
export const BRAND_ALIASES = ['DOBIDOBI', 'DoBiDoBi', 'dobi dobi', 'dobidobi', '嘟比嘟比'] as const;
export const SEO_SITE_URL = 'https://www.dobidobi.ai';
export const SEO_SITE_HOST = 'www.dobidobi.ai';
export const SEARCH_PREVIEW_IMAGE = '/search-preview-dobidobi.png';
export const GOOGLE_LOGO_IMAGE = '/logo-google.png';
export const PUBLIC_PAGE_ROBOTS: Metadata['robots'] = {
  index: true,
  follow: true,
  googleBot: {
    index: true,
    follow: true,
    'max-video-preview': -1,
    'max-image-preview': 'large',
    'max-snippet': -1,
  },
};
export const INTERNAL_REVIEW_PAGE_ROBOTS: Metadata['robots'] = {
  index: false,
  follow: false,
  googleBot: {
    index: false,
    follow: false,
  },
};

export function getSeoSiteUrl(): string {
  return SEO_SITE_URL;
}

export function buildLocalizedSeoPath(path: string, locale: SeoLocale): string {
  const url = new URL(path || '/', 'https://locale.invalid');
  if (locale === 'en') url.searchParams.delete('lang');
  else url.searchParams.set('lang', locale);
  return `${url.pathname}${url.search}${url.hash}`;
}

export function buildLocalizedAlternates(path: string, locale: SeoLocale): NonNullable<Metadata['alternates']> {
  const normalizedPath = path || '/';

  return {
    canonical: buildAbsoluteSeoUrl(buildLocalizedSeoPath(normalizedPath, locale)),
    languages: {
      ...Object.fromEntries(Object.entries(localeDefinitions).map(([key, value]) => [
        value.html, buildAbsoluteSeoUrl(buildLocalizedSeoPath(normalizedPath, key as Locale)),
      ])),
      'x-default': buildAbsoluteSeoUrl(normalizedPath),
    },
  };
}

export function buildAbsoluteSeoUrl(path: string): string {
  return new URL(path || '/', `${getSeoSiteUrl()}/`).toString();
}

export function buildAbsoluteSeoImageUrl(path: string): string {
  return new URL(path, `${getSeoSiteUrl()}/`).toString();
}

export function buildPreviewImage(alt: string, url = SEARCH_PREVIEW_IMAGE) {
  return {
    url,
    width: 1200,
    height: 1200,
    alt,
  };
}
